import $ from 'jquery';
import 'jquery-mask-plugin';

export default class DataRules {    
    static getRules(element: Element) {
        var input = $(element),
            dataRules = input.attr('data-rules');

        var rules = (dataRules ? dataRules.split(';') : []).map(function (item) {
            var rule = item.split(':');
            return { name: rule[0].trim(), options: rule[1] ? rule[1].trim() : undefined };
        }).filter(function (rule) { return rule.name; });

        return rules;
    }

    static rule(element: Element, condition, message: string, type: string = null) {
        var input = $(element),
            formControl = input.closest('.uk-form-controls'),
            select2 = input.siblings('.select2').children('.selection').children('.select2-selection'),
            messageContainer = formControl.find('.message');

        type = type || 'error';

        if (condition) {
            formControl.removeClass('warning error').addClass(type);
            if (!messageContainer.length) {
                messageContainer = $('<div/>', { 'class': 'message error uk-text-danger' });
                formControl.append(messageContainer);
            }

            input.addClass('uk-form-danger');
            select2.addClass('uk-form-danger');
            messageContainer.html(message);
        } else {
            formControl.removeClass('warning error');
            input.removeClass('uk-form-danger');
            select2.removeClass('uk-form-danger');
            messageContainer.remove();
        }

        return condition;
    };
}
